var _style, _filter, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyGoalBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 542 412",
    style: {
      enableBackground: "new 0 0 542 412"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st-goal-back0{opacity:0.6;fill:url(#SVGID_1_);}\n\t.st-goal-back1{filter:url(#b);}\n\t.st-goal-back2{fill:#FFFBBF;}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 321.944,
    id: "b",
    width: 412.25,
    x: 52.2007,
    y: 36
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_5411_9276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5411_9276",
    mode: "normal",
    result: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa-goal-back_1"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 125.7024,
    cy: 350.5333,
    r: 1,
    gradientTransform: "matrix(0 205 270 0 -94373 -25563)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9268,
    style: {
      stopColor: "#FFAF22",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back0",
    d: "M286.7,411c3.3-0.1,6.5-0.3,9.8-0.6l-6-107.6l37.1,104c3.2-0.5,6.4-1.1,9.6-1.7l-27.5-105.7l57.5,98.5 c3.1-0.9,6.1-1.8,9.1-2.8l-48.5-101.3l76.7,90.7c2.8-1.2,5.7-2.5,8.4-3.8l-68.2-94.5l94,80.7c2.6-1.5,5.1-3.1,7.6-4.7l-86.4-85.5 L469,345.7c2.2-1.8,4.4-3.7,6.5-5.6l-102.7-74.5l121.8,55.5c1.8-2.1,3.6-4.1,5.3-6.2l-116.5-61.8l131.6,40.7c1.4-2.2,2.7-4.5,4-6.8 l-127.7-47.6l138.4,25c0.9-2.4,1.8-4.8,2.6-7.2l-135.8-32.2l141.8,8.7c0.4-2.4,0.8-4.9,1.1-7.4L399,210.4l142-7.9 c-0.1-2.5-0.2-5-0.3-7.4l-142.4,0.4l138.9-24.3c-0.5-2.4-1.2-4.9-1.8-7.3l-140.8,16.9L527,140.7c-1-2.3-2.1-4.7-3.3-7l-135.8,33.1 l122.9-55c-1.5-2.2-3.1-4.4-4.7-6.5l-127.6,48.5L489,85.1c-1.9-2-3.9-4-5.9-5.9l-116.4,62.7l95.4-80.7c-2.3-1.7-4.6-3.5-7-5.1 l-102.5,75.5l78.1-90.9c-2.6-1.5-5.3-2.9-8-4.3L336.5,123l59-98.9c-2.9-1.1-5.8-2.2-8.7-3.3l-67.8,95.6l38.4-104.6 c-3.1-0.8-6.2-1.5-9.3-2.2l-47.8,102.4L317.1,4c-3.2-0.4-6.4-0.8-9.6-1.1l-26.7,106.7L275.9,1c-1.6,0-3.2,0-4.9,0s-3.2,0-4.9,0 l-4.9,108.5L234.5,2.9c-3.2,0.3-6.4,0.7-9.6,1.1l16.9,107.9L194,9.5c-3.1,0.7-6.2,1.4-9.3,2.2l38.4,104.7l-67.8-95.6 c-2.9,1.1-5.8,2.2-8.7,3.3l59,98.9l-86.2-86.6c-2.7,1.4-5.3,2.8-8,4.3l78.1,90.9L87,56c-2.4,1.7-4.7,3.4-7,5.1l95.4,80.7L58.9,79.2 c-2,1.9-4,3.9-5.9,5.9l110.5,68.7L35.8,105.3c-1.6,2.1-3.2,4.3-4.7,6.5l122.9,55L18.3,133.7c-1.1,2.3-2.3,4.6-3.3,7l132.5,40.1 L6.7,163.9c-0.7,2.4-1.3,4.8-1.8,7.3l138.9,24.3L1.3,195.1c-0.2,2.5-0.3,4.9-0.3,7.4l142,7.9L2.2,226.5c0.3,2.5,0.7,4.9,1.1,7.4 l141.8-8.7L9.4,257.4c0.8,2.4,1.7,4.8,2.6,7.2l138.4-25L22.8,287.1c1.3,2.3,2.6,4.5,4,6.8l131.6-40.7L41.9,314.9 c1.7,2.1,3.5,4.2,5.3,6.2l121.8-55.5L66.5,340.1c2.1,1.9,4.3,3.7,6.5,5.6l109.2-68.9l-86.4,85.5c2.5,1.6,5,3.2,7.6,4.7l94-80.7 l-68.2,94.5c2.8,1.3,5.6,2.6,8.4,3.8l76.7-90.7l-48.5,101.3c3,1,6,1.9,9.1,2.8l57.5-98.5l-27.5,105.7c3.2,0.6,6.4,1.2,9.6,1.7 l37.1-104l-6,107.6c3.2,0.2,6.5,0.4,9.8,0.6L271,304L286.7,411z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa-goal-back_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st-goal-back1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M105.5,68.8l8.2,5l9.6-0.2l-5,8.2l0.2,9.6l-8.2-5l-9.6,0.2l5-8.2L105.5,68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M187.7,73.5l5,4.6l6.7,1.1l-4.6,5l-1.1,6.7l-5-4.6l-6.7-1.1l4.6-5L187.7,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M252,36l4.6,8.4L265,49l-8.4,4.6L252,62l-4.6-8.4L239,49l8.4-4.6L252,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M300,62l4.6,8.4L313,75l-8.4,4.6L300,88l-4.6-8.4L287,75l8.4-4.6L300,62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M362.4,50l0.3,7.4l4.2,6l-7.4,0.3l-6,4.2l-0.3-7.4l-4.2-6l7.4-0.3L362.4,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M401.8,68.6l8,5.2l9.6,0l-5.2,8l0,9.6l-8-5.2l-9.6,0l5.2-8L401.8,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M56.2,110.8l7.9-0.7l6.3-4.8l0.7,7.9l4.8,6.3l-7.9,0.7l-6.3,4.8l-0.7-7.9L56.2,110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M143,109l4.6,8.4l8.4,4.6l-8.4,4.6L143,135l-4.6-8.4L130,122l8.4-4.6L143,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M222,105.6l7,6.6l9.4,1.8l-6.6,7l-1.8,9.4l-7-6.6l-9.4-1.8l6.6-7L222,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M308.5,128l3,5.5l5.5,3l-5.5,3l-3,5.5l-3-5.5l-5.5-3l5.5-3L308.5,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M257.4,284.9l6.9-6.6l2.3-9.3l6.6,6.9l9.3,2.3l-6.9,6.6l-2.3,9.3l-6.6-6.9L257.4,284.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M318.9,259.6l4.5-4.3l1.5-6.1l4.3,4.5l6.1,1.5l-4.5,4.3l-1.5,6.1l-4.3-4.5L318.9,259.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M361.3,94.6l-0.1,9.6l5.1,8.1l-9.6-0.1l-8.1,5.1l0.1-9.6l-5.1-8.1l9.6,0.1L361.3,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M444.3,122.5l6.8,6.7l9.4,2l-6.7,6.8l-2,9.4l-6.8-6.7l-9.4-2l6.7-6.8L444.3,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M101.1,272l0.9,9.5l5.9,7.5l-9.5,0.9l-7.5,5.9l-0.9-9.5l-5.9-7.5l9.5-0.9L101.1,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M135.8,324.1l5.4,7.9l8.8,3.8l-7.9,5.4l-3.8,8.8l-5.4-7.9l-8.8-3.8l7.9-5.4L135.8,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M222.3,311.3l5.8,3.3l6.6-0.3l-3.3,5.8l0.3,6.6l-5.8-3.3l-6.6,0.3l3.3-5.8L222.3,311.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M301.1,325.1l0.9,9.5l5.9,7.5l-9.5,0.9l-7.5,5.9l-0.9-9.5l-5.9-7.5l9.5-0.9L301.1,325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M342,284l3.7,5.9l6.3,3l-5.9,3.7l-3,6.3l-3.7-5.9l-6.3-3l5.9-3.7L342,284z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M245,219.1l-4.7-4.7l-6.5-1.4l4.7-4.7l1.4-6.5l4.7,4.7l6.5,1.4l-4.7,4.7L245,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M172.3,185.5l1.6-9.4l-3.7-8.8l9.4,1.6l8.8-3.7l-1.6,9.4l3.7,8.8l-9.4-1.6L172.3,185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M122.3,214.5l-2-6.7l-5.3-4.5l6.7-2l4.5-5.3l2,6.7l5.3,4.5l-6.7,2L122.3,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st-goal-back2",
    d: "M404.7,284.4l6.6,7l9.3,2.3l-7,6.6l-2.3,9.3l-6.6-7l-9.3-2.3l7-6.6L404.7,284.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyGoalBg);
export default __webpack_public_path__ + "static/media/daily_goal_bg.2d29f74d94b538406df663135e34dbd8.svg";
export { ForwardRef as ReactComponent };